import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";

export default function App() {
  let colorMode;
  colorMode = localStorage.getItem('chakra-ui-color-mode') || 'dark';
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate('/Contact-us');
  };

  const quickLinks = [
    { label: 'Home', url: '/' },
    { label: 'About Us', url: '/about' },
    { label: 'Contact Us', url: '/Contact-us' }
   
  ];
  
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        height: 'auto',
        justifyContent: 'flex-end',
      }}
    >
      {/* Main content area */}
      <div style={{ flex: 1 }}>{/* Your main content goes here */}</div>

      <MDBFooter
        className="text-center"
        style={{
          marginTop: "auto",
          background: colorMode === 'dark' 
            ? 'linear-gradient(135deg, #0f3460 0%, #1a1a2e 50%, #16213e 100%)' 
            : 'linear-gradient(135deg, #f0f4f8 0%, #e9ecef 50%, #dfe7f0 100%)',
          color: colorMode === 'dark' ? '#ffffff' : '#000000',
          boxShadow: colorMode === 'dark'
            ? '0 -16px 48px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
            : '0 -16px 48px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
          paddingTop: '64px',
          paddingBottom: '0',
          minHeight: 'auto',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Decorative Background Elements */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: 0.08,
          backgroundImage: `
            radial-gradient(circle at 15% 30%, ${colorMode === 'dark' ? 'rgba(77, 171, 247, 0.6)' : 'rgba(13, 110, 253, 0.4)'} 0%, transparent 50%),
            radial-gradient(circle at 85% 70%, ${colorMode === 'dark' ? 'rgba(177, 151, 252, 0.6)' : 'rgba(111, 66, 193, 0.4)'} 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, ${colorMode === 'dark' ? 'rgba(102, 126, 234, 0.4)' : 'rgba(79, 70, 229, 0.3)'} 0%, transparent 50%)
          `,
          pointerEvents: 'none',
          zIndex: 0
        }}></div>
        
        {/* Animated Accent Lines */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '3px',
          background: colorMode === 'dark'
            ? 'linear-gradient(90deg, rgba(77, 171, 247, 0) 0%, rgba(77, 171, 247, 0.8) 50%, rgba(77, 171, 247, 0) 100%)'
            : 'linear-gradient(90deg, rgba(13, 110, 253, 0) 0%, rgba(13, 110, 253, 0.6) 50%, rgba(13, 110, 253, 0) 100%)',
          pointerEvents: 'none',
          zIndex: 0
        }}></div>

        <MDBContainer className="p-2 position-relative" style={{paddingTop: '18px', paddingBottom: '0', zIndex: 1}}>
          {/* Main Footer Content */}
          <section className="Footer">
            {/* Top Section - Brand & Description */}
            <div style={{ marginBottom: '48px' }}>
              <div style={{
                textAlign: 'center',
                marginBottom: '32px'
              }}>
                <h2 style={{ 
                  color: colorMode === 'dark' ? '#ffffff' : '#1a1a2e',
                  fontSize: '2.5rem',
                  fontWeight: '800',
                  marginBottom: '12px',
                  background: colorMode === 'dark' 
                    ? 'none'
                    : 'linear-gradient(135deg, #0d6efd 0%, #6f42c1 100%)',
                  WebkitBackgroundClip: colorMode === 'dark' ? 'initial' : 'text',
                  WebkitTextFillColor: colorMode === 'dark' ? '#ffffff' : 'transparent',
                  backgroundClip: colorMode === 'dark' ? 'initial' : 'text',
                  letterSpacing: '-0.5px',
                  animation: 'fadeInDown 0.8s ease-out',
                  position: 'relative',
                  zIndex: 2
                }}>
                  Talent Track
                </h2>
                <p style={{ 
                  color: colorMode === 'dark' ? '#cbd5e0' : '#666666',
                  fontSize: '1.05rem',
                  maxWidth: '600px',
                  margin: '0 auto 16px',
                  lineHeight: '1.6',
                  fontWeight: '500'
                }}>
                  Your trusted partner for professional certification and examination services across the Middle East
                </p>
              </div>

              {/* Three Column Layout */}
            <MDBRow className="justify-content-center" style={{ marginBottom: '36px', gap: '24px' }}>
              {/* Prometric Authorization Column */}
              <MDBCol md={6} lg={4} className="mb-3">
                <div style={{ 
                  padding: '40px 28px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  background: colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)',
                  borderRadius: '20px',
                  border: `2px solid ${colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)'}`,
                  backdropFilter: 'blur(20px)',
                  transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.6) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.8)';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                  e.currentTarget.style.boxShadow = colorMode === 'dark'
                    ? '0 20px 60px rgba(77, 171, 247, 0.2), 0 0 40px rgba(77, 171, 247, 0.1)'
                    : '0 20px 60px rgba(13, 110, 253, 0.15), 0 0 40px rgba(13, 110, 253, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  {/* Card Accent */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '120px',
                    height: '120px',
                    background: `radial-gradient(circle, ${colorMode === 'dark' ? 'rgba(77, 171, 247, 0.2)' : 'rgba(13, 110, 253, 0.1)'} 0%, transparent 70%)`,
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ 
                      fontSize: '3.5rem',
                      marginBottom: '16px',
                      filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2))',
                      animation: 'bounce 3s infinite'
                    }}>
                      🏆
                    </div>
                    <h4 style={{ 
                      color: colorMode === 'dark' ? '#ffffff' : '#1a1a2e',
                      margin: '0 0 12px 0',
                      fontSize: '1.5rem',
                      fontWeight: '800',
                      letterSpacing: '-0.5px'
                    }}>
                      Authorized Prometric
                    </h4>
                    <p style={{ 
                      color: colorMode === 'dark' ? '#cbd5e0' : '#4a5568',
                      fontSize: '0.95rem',
                      marginBottom: '20px',
                      lineHeight: '1.7',
                      fontWeight: '500'
                    }}>
                      Official Test Center with authorized partnership status
                    </p>
                    <div style={{
                      background: colorMode === 'dark' 
                        ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                        : 'linear-gradient(135deg, #16a085 0%, #1abc9c 100%)',
                      padding: '10px 18px',
                      borderRadius: '24px',
                      fontSize: '0.75rem',
                      fontWeight: '800',
                      color: 'white',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      boxShadow: '0 8px 24px rgba(16, 185, 129, 0.4)',
                      display: 'inline-block',
                      marginBottom: '28px'
                    }}>
                      ✓ Certified & Verified
                    </div>
                  </div>

                  <a
                    href="https://www.prometric.com/exams/aae"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      background: colorMode === 'dark' 
                        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        : 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                      color: 'white',
                      textDecoration: 'none',
                      padding: '14px 28px',
                      borderRadius: '30px',
                      fontSize: '0.95rem',
                      fontWeight: '700',
                      boxShadow: '0 8px 24px rgba(79, 70, 229, 0.4)',
                      transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.8px',
                      border: 'none',
                      width: 'auto',
                      minWidth: '240px',
                      margin: '0 auto',
                      cursor: 'pointer',
                      whiteSpace: 'normal',
                      textAlign: 'center',
                      position: 'relative',
                      zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-6px)';
                      e.target.style.boxShadow = '0 16px 40px rgba(79, 70, 229, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 8px 24px rgba(79, 70, 229, 0.4)';
                    }}
                  >
                    🔗 Learn More
                  </a>
                </div>
              </MDBCol>

              {/* Quick Links Column */}
              <MDBCol md={6} lg={3} className="mb-3">
                <div style={{ 
                  padding: '40px 28px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  background: colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)',
                  borderRadius: '20px',
                  border: `2px solid ${colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)'}`,
                  backdropFilter: 'blur(20px)',
                  transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.6) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.8)';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                  e.currentTarget.style.boxShadow = colorMode === 'dark'
                    ? '0 20px 60px rgba(77, 171, 247, 0.2), 0 0 40px rgba(77, 171, 247, 0.1)'
                    : '0 20px 60px rgba(13, 110, 253, 0.15), 0 0 40px rgba(13, 110, 253, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  {/* Card Accent */}
                  <div style={{
                    position: 'absolute',
                    bottom: '-20px',
                    left: '-20px',
                    width: '140px',
                    height: '140px',
                    background: `radial-gradient(circle, ${colorMode === 'dark' ? 'rgba(177, 151, 252, 0.2)' : 'rgba(111, 66, 193, 0.1)'} 0%, transparent 70%)`,
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ fontSize: '3.5rem', marginBottom: '16px' }}>🔗</div>
                    <h4 style={{ 
                      color: colorMode === 'dark' ? '#ffffff' : '#1a1a2e',
                      margin: '0 0 28px 0',
                      fontSize: '1.4rem',
                      fontWeight: '800',
                      letterSpacing: '-0.5px'
                    }}>
                      Quick Links
                    </h4>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '14px'
                    }}>
                      {quickLinks.map((link, idx) => (
                        <a
                          key={idx}
                          href={link.url}
                          style={{
                            color: colorMode === 'dark' ? '#cbd5e0' : '#4a5568',
                            textDecoration: 'none',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            padding: '10px 12px',
                            borderRadius: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = colorMode === 'dark' ? '#4dabf7' : '#0d6efd';
                            e.target.style.background = colorMode === 'dark'
                              ? 'rgba(77, 171, 247, 0.15)'
                              : 'rgba(13, 110, 253, 0.12)';
                            e.target.style.transform = 'translateX(6px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = colorMode === 'dark' ? '#cbd5e0' : '#4a5568';
                            e.target.style.background = 'transparent';
                            e.target.style.transform = 'translateX(0)';
                          }}
                        >
                          ➜ {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </MDBCol>

              {/* Contact Column */}
              <MDBCol md={6} lg={4} className="mb-3">
                <div style={{ 
                  padding: '40px 28px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  background: colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)',
                  borderRadius: '20px',
                  border: `2px solid ${colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)'}`,
                  backdropFilter: 'blur(20px)',
                  transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.6) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.8)';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                  e.currentTarget.style.boxShadow = colorMode === 'dark'
                    ? '0 20px 60px rgba(77, 171, 247, 0.2), 0 0 40px rgba(77, 171, 247, 0.1)'
                    : '0 20px 60px rgba(13, 110, 253, 0.15), 0 0 40px rgba(13, 110, 253, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = colorMode === 'dark'
                    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%)';
                  e.currentTarget.style.borderColor = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.6)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  {/* Card Accent */}
                  <div style={{
                    position: 'absolute',
                    top: '-30px',
                    right: '-30px',
                    width: '150px',
                    height: '150px',
                    background: `radial-gradient(circle, ${colorMode === 'dark' ? 'rgba(102, 126, 234, 0.2)' : 'rgba(79, 70, 229, 0.1)'} 0%, transparent 70%)`,
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ fontSize: '3.5rem', marginBottom: '16px' }}>💬</div>
                    <h4 style={{ 
                      color: colorMode === 'dark' ? '#ffffff' : '#1a1a2e',
                      margin: '0 0 28px 0',
                      fontSize: '1.4rem',
                      fontWeight: '800',
                      letterSpacing: '-0.5px'
                    }}>
                      Get in Touch
                    </h4>
                    <div style={{ 
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                      marginBottom: '28px',
                      fontSize: '0.9rem'
                    }}>
                      <div style={{ 
                        color: colorMode === 'dark' ? '#cbd5e0' : '#4a5568'
                      }}>
                        📧 <a 
                          href="mailto:info@talenttrackedu.com"
                          style={{
                            color: colorMode === 'dark' ? '#4dabf7' : '#0d6efd',
                            textDecoration: 'none',
                            fontWeight: '700',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = colorMode === 'dark' ? '#74c0fc' : '#0056b3';
                            e.target.style.textDecoration = 'underline';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = colorMode === 'dark' ? '#4dabf7' : '#0d6efd';
                            e.target.style.textDecoration = 'none';
                          }}
                        >
                          info@talenttrackedu.com
                        </a>
                      </div>
                      <div style={{ 
                        color: colorMode === 'dark' ? '#cbd5e0' : '#4a5568'
                      }}>
                        📞 <a 
                          href="tel:+201119458444"
                          style={{
                            color: colorMode === 'dark' ? '#4dabf7' : '#0d6efd',
                            textDecoration: 'none',
                            fontWeight: '700',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => { 
                            e.target.style.color = colorMode === 'dark' ? '#74c0fc' : '#0056b3';
                            e.target.style.textDecoration = 'underline';
                          }}
                          onMouseLeave={(e) => { 
                            e.target.style.color = colorMode === 'dark' ? '#4dabf7' : '#0d6efd';
                            e.target.style.textDecoration = 'none';
                          }}
                        >
                          +20 1119 458 444
                        </a>
                      </div>
                    </div>

                    <MDBBtn
                      onClick={handleContactUsClick}
                      style={{
                        background: colorMode === 'dark' 
                          ? 'linear-gradient(135deg, #4dabf7 0%, #339af0 100%)'
                          : 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
                        border: 'none',
                        padding: '14px 28px',
                        fontSize: '0.95rem',
                        fontWeight: '700',
                        borderRadius: '30px',
                        boxShadow: '0 8px 24px rgba(77, 171, 247, 0.4)',
                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.8px',
                        width: '100%',
                        height: 'auto',
                        color: 'white',
                        transform: 'none',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.boxShadow = '0 16px 40px rgba(77, 171, 247, 0.6)';
                        e.target.style.transform = 'translateY(-6px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.boxShadow = '0 8px 24px rgba(77, 171, 247, 0.4)';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      💬 Contact Us
                    </MDBBtn>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>

            {/* Footer Divider */}
            <div style={{
              width: '100%',
              height: '1px',
              background: colorMode === 'dark' 
                ? 'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)'
                : 'linear-gradient(90deg, transparent, rgba(0,0,0,0.15), transparent)',
              margin: '36px 0'
            }}></div>
            </div>
          </section>
        </MDBContainer>

        {/* Footer Bottom Section */}
        <div className="text-center p-3" style={{ 
          color: colorMode === 'dark' ? '#a0aec0' : '#666666',
          background: colorMode === 'dark'
            ? 'rgba(0, 0, 0, 0.3)'
            : 'rgba(0, 0, 0, 0.05)',
          borderTop: `1px solid ${colorMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
          fontSize: '0.9rem',
          fontWeight: '500',
          letterSpacing: '0.3px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            flexWrap: 'wrap'
          }}>
            <span>© {new Date().getFullYear()}</span>
            <a className="m-1" href="/" style={{ 
              color: colorMode === 'dark' ? '#4dabf7' : '#0d6efd',
              textDecoration: 'none',
              fontWeight: '700',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = colorMode === 'dark' ? '#74c0fc' : '#0056b3';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = colorMode === 'dark' ? '#4dabf7' : '#0d6efd';
            }}>
              Talent Track
            </a>
            <span>|</span>
            <span>All rights reserved</span>
          </div>
          {/* <p style={{ margin: '8px 0 0 0', fontSize: '0.8rem', opacity: 0.8 }}>
            Designed with ❤️ for educational excellence
          </p> */}
        </div>
      </MDBFooter>
    </div>
  );
}
